<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">修 改</el-button>
		</div>
	</div>
</template>

<script>
	import {
		house_list,
		administrator_changepwd
	} from "@/api/api.js"
	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '新密码',
					model: 'password'
				}],
				inputmodel: {
					password: '',
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
				},
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							var data = {
								id: this.item.id,
								password: this.inputmodel.password,
								repassword: this.inputmodel.password
							}
							administrator_changepwd(data).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				console.log('Selected room number:', value);
				// 你可以在这里根据 value 查找对应的 item，例如：
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			house_list().then(res => {
				const _res = res.data.list
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.sex == '男') {
				this.inputmodel.sex = '1'
				console.log(this.inputmodel.sex);
			} else {
				this.inputmodel.sex = '2'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.sex == '男') {
					this.inputmodel.sex = '1'
					console.log(this.inputmodel.sex);
				} else {
					this.inputmodel.sex = '2'
				}

			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>